/*
  SarhSoft Cross-PlatForm Engine Project
  Lnaguages: PHP, JavaScript, Node, Java.
  BackEnd: Laravel.
  FrontEnd: Vue2.
  Project Type: (Laravel,Vue Mixin) Java Cross Frame.
  Written By: M.Farhat,
  Email: m.farhat@sarhsoft.com.
  Copyright © 2026 SarhSoft All rights reserved.
*/
export default {
    code:     'Coupon',
    co_code:     'Coupon',
    code_value:     'Discount Amount',
    counter:  'Use count',
    exp_date: 'Expiration Date',

};
